/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {updateMultipleBalances} from '../api'

export const useMutationUpdateMultipleBalances = createReactQueryMutationHook('updateMultipleBalances', updateMultipleBalances)
